var map = {
	"./002-energy.svg": "4401",
	"./026-tank.svg": "db6c",
	"./042-electric_tower.svg": "0d01",
	"./403-img.png": "9dc5",
	"./403.svg": "1576",
	"./Add.png": "68b3",
	"./Asset.png": "8a63",
	"./BecomeDealer.png": "7ba1",
	"./Card balance.svg": "a5dc",
	"./Card long.png": "dd1f",
	"./Cheque.png": "5a6f",
	"./Component 3.svg": "75ca",
	"./Credit-card-background-shallow-DOF.png": "ef6d",
	"./Eterna-logo_1a.jpg": "0015",
	"./FuelMetrics.png": "5196",
	"./Golden_Bricks.svg": "2abe",
	"./Group 238.png": "9272",
	"./Group 2575.png": "fcd0",
	"./Group 3000.svg": "61e9",
	"./Group 403 (1).png": "72a2",
	"./Group 405.png": "48c1",
	"./Group 440.png": "6a0c",
	"./Group 484.png": "9027",
	"./Group 553.png": "d71f",
	"./Group 806.png": "ac8a",
	"./Group13.png": "8146",
	"./Group296.png": "7b17",
	"./Group393.svg": "3e22",
	"./Group568.png": "ffb2",
	"./Group_10680.svg": "b9f5",
	"./ISW- Logo white.png": "b51e",
	"./ISW- Logo.png": "44ec",
	"./MobileWallet.png": "194f",
	"./Page-1 (1).svg": "afed",
	"./Page-1 (3).svg": "9165",
	"./Path 517.png": "4daa",
	"./Path 52.png": "aac8",
	"./Path 586.png": "a769",
	"./Pattern.svg": "0a6c",
	"./ReferBanner.png": "73e3",
	"./Screenshot (27).png": "af49",
	"./Subtraction 7.png": "b4d6",
	"./Tankimage.png": "d351",
	"./Vector.svg": "f479",
	"./accounting.svg": "6877",
	"./acquisition.png": "18c4",
	"./add-event.png": "bb3c",
	"./address.png": "c542",
	"./admin.png": "059c",
	"./analytics (1).png": "9adb",
	"./analytics.png": "d54f",
	"./arrow - white.svg": "edd1",
	"./arrow.svg": "1106",
	"./arrowDown.svg": "7e53",
	"./arrowLeft.png": "6654",
	"./arrowRight.png": "e9a5",
	"./arrowUp.svg": "56d0",
	"./auditsale.png": "aa61",
	"./av.svg": "9244",
	"./avatar.svg": "56fc",
	"./back_arrow.png": "72b6",
	"./bank (1).svg": "76a0",
	"./bank-active.svg": "66c0",
	"./bank-building (2) (2).svg": "ab8b",
	"./bank-building (2).svg": "7619",
	"./bank-building.png": "6c7b",
	"./bank-disabled.svg": "00e7",
	"./bill (1).svg": "f2f1",
	"./black-naira.svg": "d32c",
	"./bovas_1a.png": "ec29",
	"./box-grayed.png": "7604",
	"./box.png": "42c8",
	"./branch-report.png": "f621",
	"./briefcase.svg": "5a69",
	"./building (1).svg": "6259",
	"./buildings.svg": "8429",
	"./calendar (1).png": "ac29",
	"./calendar.png": "401b",
	"./cancel-button.svg": "bc99",
	"./car(2).png": "d61a5",
	"./car-speed.png": "83cc",
	"./car-top-view.png": "74d9",
	"./car.png": "5ef9",
	"./car_icon.svg": "da57",
	"./card-active.svg": "c19b",
	"./card-disabled.svg": "cd43",
	"./cars.png": "5314",
	"./cart.png": "dcde",
	"./category.png": "54a9",
	"./category.svg": "f911",
	"./chauffer.png": "cad5",
	"./checked.png": "1442",
	"./cheque-active.svg": "b3c8",
	"./cheque-disabled.svg": "bcf9",
	"./clock (1).svg": "0932",
	"./clock (4).svg": "6d2d",
	"./clock-warning.svg": "405c",
	"./close_btn.png": "f203",
	"./cogwheels.png": "95a4",
	"./collaboration.svg": "ef89",
	"./cpu (2).svg": "16e3",
	"./cpu.svg": "a314",
	"./credit-card (2).svg": "320b",
	"./credit-card (3).svg": "9b39",
	"./credit-card (4).svg": "8b1f",
	"./credit-card (6).svg": "bf90",
	"./credit-card(1).png": "9f59",
	"./credit-card.svg": "873d",
	"./credit-cards-payment.svg": "240e",
	"./credit_card__grey.svg": "1b91",
	"./cubes-white.png": "24a6",
	"./cubes.png": "9c64",
	"./danskebank.jpg": "f411",
	"./dashboard (1).png": "7a38",
	"./dashboard (2).svg": "6578",
	"./dashbord-icon.png": "6bbd",
	"./dbankdep.png": "fba4",
	"./dcash.png": "77e2",
	"./deal-inverted.png": "2aac",
	"./deal.png": "7cc1",
	"./deal.svg": "fed9",
	"./dealer-icon.png": "c50a",
	"./debt.svg": "a262",
	"./delete-icon.svg": "cd73",
	"./desales.png": "d0d7",
	"./description.png": "cf7d",
	"./dexpenses.png": "d845",
	"./dissapointment.svg": "ecbd",
	"./document.png": "5069",
	"./download.svg": "9f0f",
	"./dpossales.png": "c28f",
	"./driver_assigned.png": "4d52",
	"./drop-of-liquid.png": "8c30",
	"./dstock.png": "9537",
	"./dtablines.png": "9fa3",
	"./e-channel.png": "602f",
	"./email (1).svg": "8a2a",
	"./email.png": "8608",
	"./employee.svg": "b989",
	"./energy.svg": "9faa",
	"./ep-logo (2).svg": "ef9c",
	"./ep-logo.svg": "8015",
	"./epump-logo.png": "7890",
	"./epump_white_logo.svg": "b615",
	"./failure icon.png": "4875",
	"./fast.png": "afdf",
	"./fill_ended.png": "b6df",
	"./fill_started.png": "0bc5",
	"./folder.png": "d6aa",
	"./fuel (10).svg": "c9eb",
	"./fuel-station (2).svg": "9a29",
	"./fuelmetrics (5).png": "d95e",
	"./gift.png": "4ef4",
	"./git_loader.gif": "1b79",
	"./gold-ingots.svg": "5b58",
	"./green-wallet.svg": "5c25",
	"./hand (1).png": "eec8",
	"./id-card.png": "8f4f",
	"./img_2.jpg": "2d75",
	"./interface.png": "6756",
	"./invoice (4).svg": "6733",
	"./invoice.png": "5fb3",
	"./license-plate.png": "7911",
	"./lightening.svg": "72a0",
	"./link.svg": "6b08",
	"./list (2).svg": "6e21",
	"./list-icon.png": "3f4e",
	"./list-inveeted.png": "2c0e",
	"./list.png": "5d42",
	"./lock.png": "c2b0",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./logout.png": "221c",
	"./longBG.png": "f6d1",
	"./measure.png": "5d52",
	"./mobieli_white_epump_logo.svg": "f674",
	"./money (3).svg": "f8c5",
	"./money(1).png": "6f07",
	"./money-background.png": "f641",
	"./money-transfer.svg": "efd0",
	"./motorbike-fleet.png": "a4ba",
	"./naira.png": "a52d",
	"./naira.svg": "a34c",
	"./naira_white.svg": "2004",
	"./newNepa.svg": "69d2",
	"./nossel.png": "959c",
	"./notification.svg": "9fe6",
	"./oil-truck.svg": "6692",
	"./online-money-transfer-isometric-wallets-with-coins_107791-121.jpg": "6977",
	"./order-processed.svg": "b7ea",
	"./order_accepted.png": "56c7",
	"./order_completed.png": "a643",
	"./order_rejected.png": "15cf",
	"./outlet icon.png": "e46f",
	"./paper-plane.png": "3ced",
	"./passage-of-time (1).png": "fccf",
	"./password.png": "c119",
	"./pattern_img.png": "bbd2",
	"./payment-method.png": "4b03",
	"./payment_completed.png": "6143",
	"./payment_confirmed.png": "a8ee",
	"./payment_pending.png": "39ba",
	"./pdf-logo.svg": "a84c",
	"./pencil-3.png": "a48a",
	"./people-management.png": "7658",
	"./phone.png": "9347",
	"./pin.svg": "567d",
	"./placeholder (1).svg": "beea",
	"./processing.png": "b9b2",
	"./product.png": "ec96",
	"./product1.png": "4072",
	"./profile-user.png": "f680",
	"./profile_banner.png": "69a8",
	"./profile_pic.png": "6642",
	"./profit-report (1).svg": "25aa",
	"./pump__icon.png": "907e",
	"./pump_icon.png": "79bb",
	"./pumpimage.png": "5ce2",
	"./purple_car.png": "bdeb",
	"./purple_chauffer.png": "4ea8",
	"./purse.png": "7618",
	"./racing.png": "c329",
	"./rainoil_1a.jpg": "786e",
	"./random.svg": "8728",
	"./rating.png": "affb",
	"./rating1.png": "4433",
	"./receipt (1).png": "6fd0",
	"./receipt-inverted.png": "ddec",
	"./receipt-white.png": "fba6",
	"./receipt.png": "8a81",
	"./red-wallet.svg": "0074",
	"./remis-fleet.png": "61aa",
	"./remis-pin.svg": "668d",
	"./remisAD.png": "d725",
	"./remove (1).png": "bc03",
	"./repairing-service.png": "cf12",
	"./retain.jpg": "0688",
	"./return.png": "b6bc",
	"./roll.svg": "0a87",
	"./sale.png": "42f0",
	"./save-money.png": "aef0",
	"./search.png": "1e5e",
	"./service.png": "4a0e",
	"./share.svg": "8096",
	"./shuffle (2).svg": "5e49",
	"./signs (2).svg": "7019",
	"./sm.png": "f7df",
	"./social-media.svg": "1fe7",
	"./ss.svg": "0224",
	"./store-inv.png": "976d",
	"./store.png": "dbb4",
	"./supply-chain.png": "8eb7",
	"./surface1.png": "c1ae",
	"./suv.png": "38dd",
	"./tanks_icon.png": "025b",
	"./target (1) (1).svg": "005b",
	"./target (1).svg": "bc12",
	"./team(1).png": "38b8",
	"./teamwork.png": "ca4f",
	"./technical-support.png": "8f0a",
	"./to-do.png": "e251",
	"./tour (1).svg": "b0f1",
	"./tour.png": "0f40",
	"./transaction.svg": "ea46",
	"./transaction_receipt (5).pdf": "ac0d",
	"./transportation.svg": "0c4e",
	"./truck (1).png": "5ebb",
	"./uk-flag.png": "66a5",
	"./update-price.png": "fd53",
	"./user (1).png": "23a2",
	"./user.png": "0f71",
	"./user1.png": "7cb8",
	"./users-group.png": "0866",
	"./voucher.png": "5c50",
	"./wa-p.png": "321c",
	"./wallet (1).svg": "2525",
	"./wallet (6).svg": "00b4",
	"./wallet-grey.svg": "4c59",
	"./wallet.png": "1e5a",
	"./wallet.svg": "c2e1",
	"./wallet_debt.svg": "685c",
	"./white_logo.svg": "2ec8e",
	"./whitehand.svg": "dcff",
	"./y.png": "adbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";